angular.module('mtic.components.notifications')
.directive('teacherOnboardingPrompt', function ($log, EventManager, $timeout, language, api, notificationService) {
  return {
    templateUrl: 'template.html',
    scope: {
        setResource: '=?'
    },
    link: function (scope) {
      var eventManager = new EventManager('teacherOnboardingPrompt');
      scope.languageService = language;
    }
  }
})
